"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SelectEvent = void 0;

var _Collection = _interopRequireDefault(require("../Collection.js"));

var _CollectionEventType = _interopRequireDefault(require("../CollectionEventType.js"));

var _Event = _interopRequireDefault(require("../events/Event.js"));

var _GeometryType = _interopRequireDefault(require("../geom/GeometryType.js"));

var _Interaction = _interopRequireDefault(require("./Interaction.js"));

var _Vector = _interopRequireDefault(require("../layer/Vector.js"));

var _functions = require("../functions.js");

var _obj = require("../obj.js");

var _Style = require("../style/Style.js");

var _array = require("../array.js");

var _util = require("../util.js");

var _condition = require("../events/condition.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/interaction/Select
 */


/**
 * @enum {string}
 */
var SelectEventType = {
  /**
   * Triggered when feature(s) has been (de)selected.
   * @event SelectEvent#select
   * @api
   */
  SELECT: 'select'
};
/**
 * A function that takes an {@link module:ol/Feature~Feature} or
 * {@link module:ol/render/Feature~RenderFeature} and an
 * {@link module:ol/layer/Layer~Layer} and returns `true` if the feature may be
 * selected or `false` otherwise.
 * @typedef {function(import("../Feature.js").FeatureLike, import("../layer/Layer.js").default<import("../source/Source").default>):boolean} FilterFunction
 */

/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [addCondition] A function
 * that takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled.
 * By default, this is {@link module:ol/events/condition.never}. Use this if you
 * want to use different events for add and remove instead of `toggle`.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. This is the event
 * for the selected features as a whole. By default, this is
 * {@link module:ol/events/condition.singleClick}. Clicking on a feature selects that
 * feature and removes any that were in the selection. Clicking outside any
 * feature removes all from the selection.
 * See `toggle`, `add`, `remove` options for adding/removing extra features to/
 * from the selection.
 * @property {Array<import("../layer/Layer.js").default>|function(import("../layer/Layer.js").default<import("../source/Source").default>): boolean} [layers]
 * A list of layers from which features should be selected. Alternatively, a
 * filter function can be provided. The function will be called for each layer
 * in the map and should return `true` for layers that you want to be
 * selectable. If the option is absent, all visible layers will be considered
 * selectable.
 * @property {import("../style/Style.js").StyleLike|null} [style]
 * Style for the selected features. By default the default edit style is used
 * (see {@link module:ol/style/Style~Style}). Set to `null` if this interaction should not apply
 * any style changes for selected features.
 * If set to a falsey value, the selected feature's style will not change.
 * @property {import("../events/condition.js").Condition} [removeCondition] A function
 * that takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled.
 * By default, this is {@link module:ol/events/condition.never}. Use this if you
 * want to use different events for add and remove instead of `toggle`.
 * @property {import("../events/condition.js").Condition} [toggleCondition] A function
 * that takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. This is in addition
 * to the `condition` event. By default,
 * {@link module:ol/events/condition.shiftKeyOnly}, i.e. pressing `shift` as
 * well as the `condition` event, adds that feature to the current selection if
 * it is not currently selected, and removes it if it is. See `add` and `remove`
 * if you want to use different events instead of a toggle.
 * @property {boolean} [multi=false] A boolean that determines if the default
 * behaviour should select only single features or all (overlapping) features at
 * the clicked map position. The default of `false` means single select.
 * @property {import("../Collection.js").default<import("../Feature.js").default>} [features]
 * Collection where the interaction will place selected features. Optional. If
 * not set the interaction will create a collection. In any case the collection
 * used by the interaction is returned by
 * {@link module:ol/interaction/Select~Select#getFeatures}.
 * @property {FilterFunction} [filter] A function
 * that takes an {@link module:ol/Feature~Feature} and an
 * {@link module:ol/layer/Layer~Layer} and returns `true` if the feature may be
 * selected or `false` otherwise.
 * @property {number} [hitTolerance=0] Hit-detection tolerance. Pixels inside
 * the radius around the given position will be checked for features.
 */

/**
 * @classdesc
 * Events emitted by {@link module:ol/interaction/Select~Select} instances are instances of
 * this type.
 */

var SelectEvent =
/** @class */
function (_super) {
  __extends(SelectEvent, _super);
  /**
   * @param {SelectEventType} type The event type.
   * @param {Array<import("../Feature.js").default>} selected Selected features.
   * @param {Array<import("../Feature.js").default>} deselected Deselected features.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Associated
   *     {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
   */


  function SelectEvent(type, selected, deselected, mapBrowserEvent) {
    var _this = _super.call(this, type) || this;
    /**
     * Selected features array.
     * @type {Array<import("../Feature.js").default>}
     * @api
     */


    _this.selected = selected;
    /**
     * Deselected features array.
     * @type {Array<import("../Feature.js").default>}
     * @api
     */

    _this.deselected = deselected;
    /**
     * Associated {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
     * @type {import("../MapBrowserEvent.js").default}
     * @api
     */

    _this.mapBrowserEvent = mapBrowserEvent;
    return _this;
  }

  return SelectEvent;
}(_Event["default"]);

exports.SelectEvent = SelectEvent;

/**
 * Original feature styles to reset to when features are no longer selected.
 * @type {Object<number, import("../style/Style.js").default|Array<import("../style/Style.js").default>|import("../style/Style.js").StyleFunction>}
 */
var originalFeatureStyles = {};
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'select', SelectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active'|'select', Return>} SelectOnSignature
 */

/**
 * @classdesc
 * Interaction for selecting vector features. By default, selected features are
 * styled differently, so this interaction can be used for visual highlighting,
 * as well as selecting features for other actions, such as modification or
 * output. There are three ways of controlling which features are selected:
 * using the browser event as defined by the `condition` and optionally the
 * `toggle`, `add`/`remove`, and `multi` options; a `layers` filter; and a
 * further feature filter using the `filter` option.
 *
 * @fires SelectEvent
 * @api
 */

var Select =
/** @class */
function (_super) {
  __extends(Select, _super);
  /**
   * @param {Options} [opt_options] Options.
   */


  function Select(opt_options) {
    var _this = _super.call(this) || this;
    /***
     * @type {SelectOnSignature<import("../events").EventsKey>}
     */


    _this.on;
    /***
     * @type {SelectOnSignature<import("../events").EventsKey>}
     */

    _this.once;
    /***
     * @type {SelectOnSignature<void>}
     */

    _this.un;
    var options = opt_options ? opt_options : {};
    /**
     * @private
     */

    _this.boundAddFeature_ = _this.addFeature_.bind(_this);
    /**
     * @private
     */

    _this.boundRemoveFeature_ = _this.removeFeature_.bind(_this);
    /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */

    _this.condition_ = options.condition ? options.condition : _condition.singleClick;
    /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */

    _this.addCondition_ = options.addCondition ? options.addCondition : _condition.never;
    /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */

    _this.removeCondition_ = options.removeCondition ? options.removeCondition : _condition.never;
    /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */

    _this.toggleCondition_ = options.toggleCondition ? options.toggleCondition : _condition.shiftKeyOnly;
    /**
     * @private
     * @type {boolean}
     */

    _this.multi_ = options.multi ? options.multi : false;
    /**
     * @private
     * @type {FilterFunction}
     */

    _this.filter_ = options.filter ? options.filter : _functions.TRUE;
    /**
     * @private
     * @type {number}
     */

    _this.hitTolerance_ = options.hitTolerance ? options.hitTolerance : 0;
    /**
     * @private
     * @type {import("../style/Style.js").default|Array<import("../style/Style.js").default>|import("../style/Style.js").StyleFunction|null}
     */

    _this.style_ = options.style !== undefined ? options.style : getDefaultStyleFunction();
    /**
     * @private
     * @type {import("../Collection.js").default}
     */

    _this.features_ = options.features || new _Collection["default"]();
    /** @type {function(import("../layer/Layer.js").default<import("../source/Source").default>): boolean} */

    var layerFilter;

    if (options.layers) {
      if (typeof options.layers === 'function') {
        layerFilter = options.layers;
      } else {
        var layers_1 = options.layers;

        layerFilter = function layerFilter(layer) {
          return (0, _array.includes)(layers_1, layer);
        };
      }
    } else {
      layerFilter = _functions.TRUE;
    }
    /**
     * @private
     * @type {function(import("../layer/Layer.js").default<import("../source/Source").default>): boolean}
     */


    _this.layerFilter_ = layerFilter;
    /**
     * An association between selected feature (key)
     * and layer (value)
     * @private
     * @type {Object<string, import("../layer/Layer.js").default>}
     */

    _this.featureLayerAssociation_ = {};
    return _this;
  }
  /**
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {import("../layer/Layer.js").default} layer Layer.
   * @private
   */


  Select.prototype.addFeatureLayerAssociation_ = function (feature, layer) {
    this.featureLayerAssociation_[(0, _util.getUid)(feature)] = layer;
  };
  /**
   * Get the selected features.
   * @return {import("../Collection.js").default<import("../Feature.js").default>} Features collection.
   * @api
   */


  Select.prototype.getFeatures = function () {
    return this.features_;
  };
  /**
   * Returns the Hit-detection tolerance.
   * @return {number} Hit tolerance in pixels.
   * @api
   */


  Select.prototype.getHitTolerance = function () {
    return this.hitTolerance_;
  };
  /**
   * Returns the associated {@link module:ol/layer/Vector~VectorLayer vector layer} of
   * a selected feature.
   * @param {import("../Feature.js").FeatureLike} feature Feature
   * @return {import('../layer/Vector.js').default} Layer.
   * @api
   */


  Select.prototype.getLayer = function (feature) {
    return (
      /** @type {import('../layer/Vector.js').default} */
      this.featureLayerAssociation_[(0, _util.getUid)(feature)]
    );
  };
  /**
   * Hit-detection tolerance. Pixels inside the radius around the given position
   * will be checked for features.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @api
   */


  Select.prototype.setHitTolerance = function (hitTolerance) {
    this.hitTolerance_ = hitTolerance;
  };
  /**
   * Remove the interaction from its current map, if any,  and attach it to a new
   * map, if any. Pass `null` to just remove the interaction from the current map.
   * @param {import("../PluggableMap.js").default|null} map Map.
   * @api
   */


  Select.prototype.setMap = function (map) {
    var currentMap = this.getMap();

    if (currentMap && this.style_) {
      this.features_.forEach(this.restorePreviousStyle_.bind(this));
    }

    _super.prototype.setMap.call(this, map);

    if (map) {
      this.features_.addEventListener(_CollectionEventType["default"].ADD, this.boundAddFeature_);
      this.features_.addEventListener(_CollectionEventType["default"].REMOVE, this.boundRemoveFeature_);

      if (this.style_) {
        this.features_.forEach(this.applySelectedStyle_.bind(this));
      }
    } else {
      this.features_.removeEventListener(_CollectionEventType["default"].ADD, this.boundAddFeature_);
      this.features_.removeEventListener(_CollectionEventType["default"].REMOVE, this.boundRemoveFeature_);
    }
  };
  /**
   * @param {import("../Collection.js").CollectionEvent} evt Event.
   * @private
   */


  Select.prototype.addFeature_ = function (evt) {
    var feature = evt.element;

    if (this.style_) {
      this.applySelectedStyle_(feature);
    }

    if (!this.getLayer(feature)) {
      var layer =
      /** @type {VectorLayer} */
      this.getMap().getAllLayers().find(function (layer) {
        if (layer instanceof _Vector["default"] && layer.getSource() && layer.getSource().hasFeature(feature)) {
          return layer;
        }
      });

      if (layer) {
        this.addFeatureLayerAssociation_(feature, layer);
      }
    }
  };
  /**
   * @param {import("../Collection.js").CollectionEvent} evt Event.
   * @private
   */


  Select.prototype.removeFeature_ = function (evt) {
    var feature = evt.element;

    if (this.style_) {
      this.restorePreviousStyle_(feature);
    }
  };
  /**
   * @return {import("../style/Style.js").StyleLike|null} Select style.
   */


  Select.prototype.getStyle = function () {
    return this.style_;
  };
  /**
   * @param {import("../Feature.js").default} feature Feature
   * @private
   */


  Select.prototype.applySelectedStyle_ = function (feature) {
    var key = (0, _util.getUid)(feature);

    if (!(key in originalFeatureStyles)) {
      originalFeatureStyles[key] = feature.getStyle();
    }

    feature.setStyle(this.style_);
  };
  /**
   * @param {import("../Feature.js").default} feature Feature
   * @private
   */


  Select.prototype.restorePreviousStyle_ = function (feature) {
    var interactions = this.getMap().getInteractions().getArray();

    for (var i = interactions.length - 1; i >= 0; --i) {
      var interaction = interactions[i];

      if (interaction !== this && interaction instanceof Select && interaction.getStyle() && interaction.getFeatures().getArray().lastIndexOf(feature) !== -1) {
        feature.setStyle(interaction.getStyle());
        return;
      }
    }

    var key = (0, _util.getUid)(feature);
    feature.setStyle(originalFeatureStyles[key]);
    delete originalFeatureStyles[key];
  };
  /**
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @private
   */


  Select.prototype.removeFeatureLayerAssociation_ = function (feature) {
    delete this.featureLayerAssociation_[(0, _util.getUid)(feature)];
  };
  /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} and may change the
   * selected state of features.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @this {Select}
   */


  Select.prototype.handleEvent = function (mapBrowserEvent) {
    if (!this.condition_(mapBrowserEvent)) {
      return true;
    }

    var add = this.addCondition_(mapBrowserEvent);
    var remove = this.removeCondition_(mapBrowserEvent);
    var toggle = this.toggleCondition_(mapBrowserEvent);
    var set = !add && !remove && !toggle;
    var map = mapBrowserEvent.map;
    var features = this.getFeatures();
    var deselected = [];
    var selected = [];

    if (set) {
      // Replace the currently selected feature(s) with the feature(s) at the
      // pixel, or clear the selected feature(s) if there is no feature at
      // the pixel.
      (0, _obj.clear)(this.featureLayerAssociation_);
      map.forEachFeatureAtPixel(mapBrowserEvent.pixel,
      /**
       * @param {import("../Feature.js").FeatureLike} feature Feature.
       * @param {import("../layer/Layer.js").default} layer Layer.
       * @return {boolean|undefined} Continue to iterate over the features.
       */
      function (feature, layer) {
        if (this.filter_(feature, layer)) {
          this.addFeatureLayerAssociation_(feature, layer);
          selected.push(feature);
          return !this.multi_;
        }
      }.bind(this), {
        layerFilter: this.layerFilter_,
        hitTolerance: this.hitTolerance_
      });

      for (var i = features.getLength() - 1; i >= 0; --i) {
        var feature = features.item(i);
        var index = selected.indexOf(feature);

        if (index > -1) {
          // feature is already selected
          selected.splice(index, 1);
        } else {
          features.remove(feature);
          deselected.push(feature);
        }
      }

      if (selected.length !== 0) {
        features.extend(selected);
      }
    } else {
      // Modify the currently selected feature(s).
      map.forEachFeatureAtPixel(mapBrowserEvent.pixel,
      /**
       * @param {import("../Feature.js").FeatureLike} feature Feature.
       * @param {import("../layer/Layer.js").default} layer Layer.
       * @return {boolean|undefined} Continue to iterate over the features.
       */
      function (feature, layer) {
        if (this.filter_(feature, layer)) {
          if ((add || toggle) && !(0, _array.includes)(features.getArray(), feature)) {
            this.addFeatureLayerAssociation_(feature, layer);
            selected.push(feature);
          } else if ((remove || toggle) && (0, _array.includes)(features.getArray(), feature)) {
            deselected.push(feature);
            this.removeFeatureLayerAssociation_(feature);
          }

          return !this.multi_;
        }
      }.bind(this), {
        layerFilter: this.layerFilter_,
        hitTolerance: this.hitTolerance_
      });

      for (var j = deselected.length - 1; j >= 0; --j) {
        features.remove(deselected[j]);
      }

      features.extend(selected);
    }

    if (selected.length > 0 || deselected.length > 0) {
      this.dispatchEvent(new SelectEvent(SelectEventType.SELECT, selected, deselected, mapBrowserEvent));
    }

    return true;
  };

  return Select;
}(_Interaction["default"]);
/**
 * @return {import("../style/Style.js").StyleFunction} Styles.
 */


function getDefaultStyleFunction() {
  var styles = (0, _Style.createEditingStyle)();
  (0, _array.extend)(styles[_GeometryType["default"].POLYGON], styles[_GeometryType["default"].LINE_STRING]);
  (0, _array.extend)(styles[_GeometryType["default"].GEOMETRY_COLLECTION], styles[_GeometryType["default"].LINE_STRING]);
  return function (feature) {
    if (!feature.getGeometry()) {
      return null;
    }

    return styles[feature.getGeometry().getType()];
  };
}

var _default = Select;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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